/* eslint-disable no-underscore-dangle */
import { Options } from '@contentful/rich-text-react-renderer';
import {
  DownloadBlock,
  AccordionBlock,
  ScrollerBlockProps,
  StickyJumpNavigationItemProps,
} from '@stadionhq-v3/base-ui';
import {
  ContentScrollerBlock,
  DownloadBlock as DownloadBlockType,
  AccordionBlock as AccordionBlockType,
} from '@graphql/__generated__/graphql';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { Translations } from '@lib/dictionary-keys/__generated__';
import { StreamVideoAndOverlayWrapperDictionary } from '@components/helpers/stream-video-and-overlay-wrapper';
import { THEMES } from '@stadionhq-v3/core';
import accordionBlockTransform from './accordionBlock.transform';
import downloadBlockTransform from './downloadBlock.transform';

export type ScrollerBlockTransformSettings = {
  useNextImage?: boolean;
  richTextRenderOptions?: Options;
};

const scrollerBlockTransform = (
  {
    scrollerBlockTitle,
    contentSections,
  }: CleanContentful<ContentScrollerBlock>,
  dictionary: Pick<Translations['common']['action'], 'next' | 'previous'> &
    StreamVideoAndOverlayWrapperDictionary
  // setting: ScrollerBlockTransformSettings
): ScrollerBlockProps => ({
  stickyJumpNavigationProps: {
    title: scrollerBlockTitle,
    items: contentSections?.map((item) => ({
      id: item?.id,
      title: item?.title,
    })) as StickyJumpNavigationItemProps[],
  },
  items: contentSections?.map((item) => {
    if (item?.__typename === 'DownloadBlock') {
      return (
        <DownloadBlock
          key={item.id}
          {...downloadBlockTransform(
            item as CleanContentful<DownloadBlockType>,
            THEMES.COLOUR_THEME_1
          )}
          downloads={item.downloadLinks}
        />
      );
    }

    if (item?.__typename === 'AccordionBlock') {
      return (
        <AccordionBlock
          key={item.id}
          {...accordionBlockTransform(
            item as CleanContentful<AccordionBlockType>,
            dictionary,
            THEMES.COLOUR_THEME_1
          )}
        />
      );
    }
    console.warn(
      `"${item?.__typename}" not supported by "ContentScrollerBlock"!`
    );
    return undefined;
  }),
});

export default scrollerBlockTransform;
